/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../../store'

export default [
  {
    path: '*',
    meta: {
      name: '',
      requiresAuth: true
    },
    redirect: {
      path: '/dashboard'
    }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: 'login',
      title: 'GEM | Login',
      requiresAuth: false
    },
    component: () => import(`@/views/Login.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next('/dashbaord')
      } else {
        next()
      }
    }
  },
  {
    path: '/logout',
    meta: {
      name: 'logout',
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
        store.dispatch('logout')
        next('/')

    }

  },
  
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  {
    path: '/',
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: 'dashboard/:snackbar?',
        name: 'Dashboard',
        meta: {
          title: 'GEM | Dashboard',
        },
        component: () => import(`@/views/Main.vue`)
      },
    
    ]
  }
]